import script from "./EncounterListWidgetDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EncounterListWidgetDetail.vue?vue&type=script&setup=true&lang=js"

import "./EncounterListWidgetDetail.vue?vue&type=style&index=0&id=1c13e116&lang=css"

const __exports__ = script;

export default __exports__